import { createFileRoute } from "@tanstack/react-router";
import { RecordTypeRulesSection } from "./fullRules";

export const Route = createFileRoute(
	"/_authenticated/(admin-app)/_admin/admin/configuration/recordTypes/$recordTypeId/rules",
)({
	component: AdminRecordTypeRulesTab,
});

function AdminRecordTypeRulesTab() {
	return (
		<div className="px-5 pb-5">
			<RecordTypeRulesSection stayOnRoute />
		</div>
	);
}
